import React, { useState } from "react";
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import './Login.css';
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const notify = () => toast("Inavalid Username or Password !");

  const handleLogin = (e) => {
  e.preventDefault();

  if (username === "avanthika" && password === "1234") {
    login();
    toast.success("Logged in successfully! ✅");
    setTimeout(() => navigate("/home"), 2000);
  } else {
    toast.error("Invalid Username or Password ❌");
  }
};

  return (
    <div className="login">
      <Form onSubmit={handleLogin}>
        <h1>Login</h1>
        <Form.Group className="mb-4">
          <Form.Label>Username</Form.Label>
          <Form.Control
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Form.Group>

        <Button variant="primary" type="submit">
          Login
        </Button>
        <ToastContainer />
      </Form>
    </div>
  );
}

export default Login;
